<div class="btn-filter">
    <div class="search-controls">
        <!-- an icon, like its neighbours, to keep the bar to one line (#173); the word is the tooltip -->
        <action-button
            class="btn-search"
            (actionEvent)="search($event)"
            label=""
            icon="search"
            [title]="'headerFilters.searchButton' | translate"
            [ngClass]="'btn-search'"
            >
        </action-button>
        <filter-buttons
            (addFilter)="goToFilterPalette()"
            (clearFilters)="clearAllFilters()"
            >
        </filter-buttons>
    </div>
    <selected-filters
        [selectedFilters]="selectedFilters"
        (removeFilter)="removeFilter($event)"
        >
    </selected-filters>
</div>
